import { TextField } from '@ff-it/form';
import { OOHCategoryFormatField } from './OOHCategoryFormatField';
import { required } from 'utilities';
import { OOHFormatForm } from './OOHFormatForm';
import type { ConfigProps } from 'modules/supplier/products/Config/types';

export function OOHConfigForm(_: ConfigProps) {
  const half = 'col-6';
  return (
    <>
      <div className="form-row">
        <OOHCategoryFormatField
          name="configuration.category_format"
          label="Category"
          className={half ?? 'col-md-5'}
          required
          validate={required}
        />
        <TextField
          name="configuration.code_or_number"
          label="Code or number"
          className={half ?? 'col-md-2'}
          help="Vendor product code or number"
        />
      </div>
      <div className="col-12 px-0">
        <OOHFormatForm name="configuration.format." />
      </div>
    </>
  );
}
